import * as types from '../../mutation-types';
import InboxesAPI from '../../../api/inboxes';
import AnalyticsHelper from '../../../helper/AnalyticsHelper';
import { ACCOUNT_EVENTS } from '../../../helper/AnalyticsHelper/events';

export const buildInboxData = inboxParams => {
  const formData = new FormData();
  const { channel = {}, ...inboxProperties } = inboxParams;
  Object.keys(inboxProperties).forEach(key => {
    formData.append(key, inboxProperties[key]);
  });
  const { selectedFeatureFlags, ...channelParams } = channel;
  // selectedFeatureFlags needs to be empty when creating a website channel
  if (selectedFeatureFlags) {
    if (selectedFeatureFlags.length) {
      selectedFeatureFlags.forEach(featureFlag => {
        formData.append(`channel[selected_feature_flags][]`, featureFlag);
      });
    } else {
      formData.append('channel[selected_feature_flags][]', '');
    }
  }
  Object.keys(channelParams).forEach(key => {
    const value = channelParams[key];

    // LISTA vai item a item, com `[]` no nome. `FormData.append` com array serializa como
    // TEXTO — `['a', 'b']` vira `"a,b"` e um item só vira o próprio item — e do outro lado
    // `permit(chave: [])` recusa escalar EM SILÊNCIO: o PATCH devolve 200 e não grava nada.
    // Foi assim que as perguntas sugeridas do assistente não salvavam.
    //
    // O `selected_feature_flags` logo acima já sabia disso, mas resolvia num caso ESCRITO À
    // MÃO, o que fazia a próxima lista repetir o defeito. Aqui a regra é do laço.
    if (Array.isArray(value)) {
      if (value.length) {
        value.forEach(item => formData.append(`channel[${key}][]`, item));
      } else {
        // Lista vazia precisa CHEGAR, senão a chave não viaja e não há como APAGAR o que já
        // está gravado — o servidor não distingue "esvaziei" de "não mandei". Mesmo recurso
        // que o `selected_feature_flags` usa.
        formData.append(`channel[${key}][]`, '');
      }
      return;
    }

    formData.append(`channel[${key}]`, value);
  });
  return formData;
};

const sendAnalyticsEvent = channelType => {
  AnalyticsHelper.track(ACCOUNT_EVENTS.ADDED_AN_INBOX, {
    channelType,
  });
};

export const channelActions = {
  createVoiceChannel: async ({ commit }, params) => {
    try {
      commit(types.default.SET_INBOXES_UI_FLAG, { isCreating: true });
      const response = await InboxesAPI.create({
        name: params.name,
        channel: { ...params.voice, type: 'voice' },
      });
      commit(types.default.ADD_INBOXES, response.data);
      commit(types.default.SET_INBOXES_UI_FLAG, { isCreating: false });
      sendAnalyticsEvent('voice');
      return response.data;
    } catch (error) {
      commit(types.default.SET_INBOXES_UI_FLAG, { isCreating: false });
      throw error;
    }
  },
};
